import React from "react";

const AdminDashboardOneColumnLayout = props => {
    const {content} = props;
    return (
        <div className="DashboardOneColumnLayout flex w-full h-full flex-row justify-stretch flex-wrap content-between items-stretch">
            <div className="flex w-full h-full flex-col justify-start pt-4.5vh pb-4.5vh items-center">{content}</div>
        </div>
    );
};

export default AdminDashboardOneColumnLayout;
